var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14620_60742)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.703125 2.33333C0.703125 2.01117 0.964292 1.75 1.28646 1.75H14.1198C14.442 1.75 14.7031 2.01117 14.7031 2.33333V11.6667C14.7031 11.9888 14.442 12.25 14.1198 12.25H1.28646C0.964292 12.25 0.703125 11.9888 0.703125 11.6667V2.33333ZM1.86979 2.91667V11.0833H13.5365V2.91667H1.86979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39323 8.07542L0.976562 3.99208L1.60292 3.00781L7.70641 6.89185L13.8099 3.00781L14.4362 3.99208L8.01958 8.07542C7.8285 8.19701 7.58431 8.19701 7.39323 8.07542Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14620_60742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.703125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.b51b461d0efda5ef8bec782ff22dc82b.svg";
export { ForwardRef as ReactComponent };